import {MessageBox} from 'mint-ui'
import EMA from '../assets/js/singleton-ema'

export default function() {
  window.msgBox = MessageBox

  window.alert = function (msg, fn) {
    MessageBox.close()
    var m, t
    if (typeof msg === 'object') {
      m = msg.msg
      t = msg.title
    } else {
      m = String(msg)
      t = '提示'
    }
    MessageBox.alert(m, t).then(action => {
      typeof fn === 'function' && fn(action)
    })
  }

  window.confirm = function (msg, fn, re) {
    MessageBox.close()
    var m, t
    if (typeof msg === 'object') {
      m = msg.msg
      t = msg.title
    } else {
      m = String(msg)
      t = '提示'
    }
    MessageBox.confirm(m, t).then(action => {
      typeof fn === 'function' && fn(action)
    }).catch(action => {
      typeof re === 'function' && re(action)
    })
  }

  const oldPrompt = window.prompt
  window.prompt = function (msg, fn, re) {
    // 忽略钉钉的 JSBridge
    if (msg === 'nuva:exec') {
      oldPrompt(msg, fn)
      return
    }

    MessageBox.close()
    var m, t
    if (typeof msg === 'object') {
      m = msg.msg
      t = msg.title
    } else {
      m = String(msg)
      t = '提示'
    }
    MessageBox.prompt(m, t).then(val => {
      typeof fn === 'function' && fn(val)
    }).catch(action => {
      typeof re === 'function' && re(action)
    })
  }

  window.loading = function (hide) {
    if (!hide) EMA.fire('Loading.show')
    else EMA.fire('Loading.hide')
  }

  window.toast = function (msg, fn) {
    EMA.fire('Toast.show', msg, fn)
  }

  window.viewImg = (imgs, index) => {
    EMA.fire('ImgViewer.open', imgs, index)
  }
}
